import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Lenis from "lenis";
import "./App.css";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import FloatingWhatsApp from "./components/FloatingWhatsApp";
import CookieBanner from "./components/CookieBanner";
import Home from "./pages/Home";
import LaCarte from "./pages/LaCarte";
import CommentCaMarche from "./pages/CommentCaMarche";
import Configurateur from "./pages/Configurateur";
import Solutions from "./pages/Solutions";
import SolutionMetier from "./pages/SolutionMetier";
import Packs from "./pages/Packs";
import Galerie from "./pages/Galerie";
import Faq from "./pages/Faq";
import APropos from "./pages/APropos";
import Contact from "./pages/Contact";
import Legal from "./pages/Legal";
import Blog from "./pages/Blog";
import BlogArticle from "./pages/BlogArticle";
import NotFound from "./pages/NotFound";
import PublicPage from "./pages/PublicPage";
import { Login, ResetPassword } from "./pages/Login";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminClients from "./pages/admin/AdminClients";
import AdminClientDetail from "./pages/admin/AdminClientDetail";
import Espace from "./pages/espace/Espace";
import { AuthProvider } from "./platform/AuthContext";

let lenisInstance = null;

function useLenis() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    lenisInstance = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      lenisInstance = null;
    };
  }, []);
}

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (lenisInstance) lenisInstance.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function Layout() {
  useLenis();
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main id="contenu">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/la-carte" element={<LaCarte />} />
          <Route path="/comment-ca-marche" element={<CommentCaMarche />} />
          <Route path="/personnalisation" element={<Configurateur />} />
          <Route path="/solutions" element={<Solutions />} />
          <Route path="/solutions/:slug" element={<SolutionMetier />} />
          <Route path="/packs-personnalises" element={<Packs />} />
          <Route path="/galerie" element={<Galerie />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/conseils" element={<Blog />} />
          <Route path="/conseils/:slug" element={<BlogArticle />} />
          <Route path="/a-propos" element={<APropos />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/mentions-legales" element={<Legal doc="mentions-legales" />} />
          <Route path="/conditions-generales-de-prestation" element={<Legal doc="conditions-generales-de-prestation" />} />
          <Route path="/cgu" element={<Legal doc="cgu" />} />
          <Route path="/politique-de-confidentialite" element={<Legal doc="politique-de-confidentialite" />} />
          <Route path="/politique-cookies" element={<Legal doc="politique-cookies" />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
      <FloatingWhatsApp />
      <CookieBanner />
    </>
  );
}

export default function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            {/* Plateforme NFC : sans le chrome du site vitrine */}
            <Route path="/p/:slug" element={<PublicPage />} />
            <Route path="/connexion" element={<Login />} />
            <Route path="/reinitialiser-mdp/:token" element={<ResetPassword />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/admin/clients" element={<AdminClients />} />
            <Route path="/admin/clients/:clientId" element={<AdminClientDetail />} />
            <Route path="/espace" element={<Espace />} />
            {/* Site vitrine */}
            <Route path="/*" element={<Layout />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </HelmetProvider>
  );
}
